import React from 'react';
import PropTypes from 'prop-types';
import { Box, NakedButton, Text } from '@qga/roo-ui/components';
import PointsEarnDisplay from 'components/PointsEarnDisplay';
import { useTooltip } from 'lib/hooks';
import { TooltipWrapper } from './primitives';
import { HOTELS_BRAND_NAME } from 'config';
import { v4 as uuidv4 } from 'uuid';

const BusinessRewardsTooltip = ({ qbrPoints }) => {
  const tooltipId = `qbr-total-button-${uuidv4()}`;
  const { triggerProps, tooltipProps, isOpen } = useTooltip(tooltipId, 'qbr-total-button');
  const { total } = qbrPoints;

  return (
    <NakedButton {...triggerProps}>
      {total > 0 && (
        <Text display="block" fontSize="14px" color="greys.steel">
          Plus <PointsEarnDisplay fontWeight="normal" fontSize="14px" {...qbrPoints} /> PTS{' '}
          <Text color="greys.steel" fontSize="14px" textDecoration="underline">
            for your business
          </Text>
          <Text>**</Text>
        </Text>
      )}
      {isOpen && total > 0 && (
        <Box {...tooltipProps}>
          <TooltipWrapper>
            <Text>
              Travelling for business? Add your Qantas Business Rewards membership ABN number to any domestic or international{' '}
              {HOTELS_BRAND_NAME} booking and your business will earn 1 Qantas Point per A$1 spent.**
            </Text>
          </TooltipWrapper>
        </Box>
      )}
    </NakedButton>
  );
};

BusinessRewardsTooltip.propTypes = {
  qbrPoints: PropTypes.shape({ total: PropTypes.number }).isRequired,
};

export default BusinessRewardsTooltip;
